import React, { useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import About from "../about/About";
import Contact from "../contact/Contact";
import Footer from "../footer/Footer";
import Test from "../testi/Test";
import "./Home.css";
const Home = () => {
  const [nav, setnav] = useState(null);

  const handlewindo = () => {
    console.log(window.scrollY);
    if (window.scrollY > 0) {
      setnav(true);
    } else {
      setnav(false);
    }
  };
  window.addEventListener("scroll", handlewindo);
  return (
    <>
      <Navbar
        // className={nav ? "nav active" : nav}
        // className={`${nav ? "nav active" : nav} `}
        bg="dark"
        variant="dark"
        expand="lg"
        sticky="top"
        //   fixed="top"
      >
        <Container className="">
          <Navbar.Brand href="#">NazmuL-DoT</Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav
              className="ms-auto my-2 my-lg-0"
              style={{ maxHeight: "100px" }}
              navbarScroll
            >
              <Nav.Link style={{ fontWeight: "bolder" }} href="#homepage">
                Home
              </Nav.Link>

              <Nav.Link style={{ fontWeight: "bolder" }} href="#about">
                About
              </Nav.Link>

              <Nav.Link style={{ fontWeight: "bolder" }} href="#service">
                Service
              </Nav.Link>

              <Nav.Link style={{ fontWeight: "bolder" }} href="#contact">
                Contact
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Home;
